import api from './ApiMiddleware';

const SimpleNotificationSetViewed = (clientId, userId) => {
  return api.post(`/api/v1/notification/viewed`, {
    clientId,
    userId,
  });
};

const getLatestWebNotifications = () => {
  return api.get(`/api/x2/notifications/latest`);
};

const markWebNotificationsAsRead = (cutoffdate) => {
  return api.post(`/api/x2/notifications/markasread?cutoffdate=${cutoffdate}`);
};

const markSingleWebNotificationAsRead = (webNotificationId) => {
  return api.post(`/api/x2/notifications/${webNotificationId}/markasread`);
};

const NotificationService = {
  SimpleNotificationSetViewed,
  getLatestWebNotifications,
  markWebNotificationsAsRead,
  markSingleWebNotificationAsRead,
};

export default NotificationService;
